import type { DataTableColumn } from '@/components/data-table/data-table.interface'

import type { BillingUsageEntry } from './billing.interface'
import { formatUsageCurrency, formatUsageDateTime } from './billing-token-usage-table.helper'
import { BillingUsageTypeBadge } from './billing-usage-type-badge.atom'

export const createdAtColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'createdAt',
  header: 'Date/Time',
  isSortable: true,
  width: '140px',
  cell: (entry) => (
    <span className="text-sm text-muted-foreground">{formatUsageDateTime(entry.createdAt)}</span>
  ),
}

export const typeColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'type',
  header: 'Type',
  isSortable: true,
  width: '100px',
  cell: (entry) => <BillingUsageTypeBadge type={entry.type} />,
}

export const stepNameColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'stepName',
  header: 'Step',
  accessorKey: 'stepName',
  width: '160px',
}

export const resourceNameColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'resourceName',
  header: 'Resource',
  accessorKey: 'resourceName',
  width: '160px',
}

export const userNameColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'userName',
  header: 'User',
  accessorKey: 'userName',
  width: '140px',
}

export const costAmountColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'costAmount',
  header: 'Cost',
  isSortable: true,
  width: '100px',
  align: 'right',
  cell: (entry) => (
    <span className="font-medium tabular-nums">{formatUsageCurrency(entry.costAmount)}</span>
  ),
}

export const chatNameColumn: DataTableColumn<BillingUsageEntry> = {
  id: 'chatName',
  header: 'Chat',
  width: '180px',
  cell: (entry) => {
    if (!entry.chatName) {
      return <span className="text-muted-foreground">—</span>
    }
    return <span className="text-sm">{entry.chatName}</span>
  },
}
